import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { B2B_ORDER_URL } from 'utils/constans/constans';
import { formatPrice } from '../../utils/numberFormatter';
import { RowItems } from '../../models/TableProps';
import { InvoiceData } from '../../models/Invoice';
import useInvoiceDetailsDialog from '../../hooks/dialogs/useInvoiceDetailsDialog';
import { Button } from '@mui/material';

export const InvoicesTableRow: React.FC<RowItems<InvoiceData>> = (props) => {
    const { row, index } = props;
    const { t } = useTranslation('invoices');
    const labelId = `enhanced-table-checkbox-${index}`;
    const invoiceDetailsDialog = useInvoiceDetailsDialog();

    return (
        <TableRow hover>
            <TableCell component="th" id={labelId} scope="row">
                {row.invoiceNumber}
            </TableCell>
            <TableCell align="right">{row.date}</TableCell>
            <TableCell align="right">{row.paid}</TableCell>
            <TableCell align="right">{row.paymentDeadline}</TableCell>
            <TableCell align="right">{formatPrice(row.price_net)} Ft</TableCell>
            <TableCell align="right">
                {formatPrice(row.price_gross)} Ft
            </TableCell>
            <TableCell align="right">
                {row.status &&
                    row.status != ' ' &&
                    t(
                        'INVOICES.TABLE_CONTENT.STATUS.' +
                            row.status
                                .toString()
                                .toUpperCase()
                                .replace(' ', '_')
                    )}
            </TableCell>
            <TableCell align="right">
                {row.shopifyOrderId && (
                    <a
                        href={
                            B2B_ORDER_URL +
                            row.shopifyOrderId.split('(')[1].slice(0, -1)
                        }
                    >
                        {row.shopifyOrderId.split('(')[0]}
                    </a>
                )}
            </TableCell>
            <TableCell align="right">
                <Button
                    onClick={() => invoiceDetailsDialog.showDialog(true, row)}
                >
                    {t('INVOICES.TABLE_CONTENT.SHOW')}
                </Button>
            </TableCell>
        </TableRow>
    );
};
